import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './njitSearch.scss';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 320,
    maxWidth: 500,
  },
  button: {
    margin: '10px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};



class NjitSearch extends Component {


  	constructor(props) {
	    super(props);
	    this.state = {
			data:{},
			types: [],
			indexes: [],
			loaded:false,
			query_string: '',
			select_types: [],
			select_indexes: []
	    };
	    this.handleChange = this.handleChange.bind(this);
	    this.handleSubmit = this.handleSubmit.bind(this);
	    this.clearResults = this.clearResults.bind(this);
	    
  	}	
  
  	componentDidMount() {
  		this.getTypes();
		this.getIndexes();
	}

	getIndexes() {
		let paramsBody = {
			"aggs": {
				"indexesAgg": {
			      "terms": {
			        "field": "_index",
			        "size": 200
			      }
			    }
			},
			"size": 0
		}
		 axios({
		      method: 'POST',
		      url: '/search-api/_search',
		      headers: {
		        'Content-Type': 'application/json'
		      },
		      data: JSON.stringify(paramsBody)
		    }).then((response) => {
		      //console.log('response.data', response.data.aggregations.typesAgg.buckets);
		      this.setState({ indexes:  response.data.aggregations.indexesAgg.buckets},() => {
		      });
		    })
		    .catch((error) => {
		      //console.log(error);
		    });
	}

	clearResults() {
		this.setState({ data: {}},() => {});
	}


	getTypes() {
		let paramsBody = {
			"aggs": {
				"typesAgg": {
				  "terms": {
				    "field": "_type",
				    "size": 200
				  }
				}
			},
			"size": 0
		}
		 axios({
		      method: 'POST',
		      url: '/search-api/_search',
		      headers: {
		        'Content-Type': 'application/json'
		      },
		      data: JSON.stringify(paramsBody)
		    }).then((response) => {
		      //console.log('response.data', response.data.aggregations.typesAgg.buckets);
		      this.setState({ types:  response.data.aggregations.typesAgg.buckets},() => {
		      });
		    })
		    .catch((error) => {
		      //console.log(error);
		    });
		    
	}
	getIndexesForSearch() {
		if(this.state.select_indexes.length) {
			return this.state.select_indexes.join(',')+'/';
		} else {
			return '_all/';
		}
	}
	getTypesForSearch() {
		if(this.state.select_types.length) {
			return this.state.select_types.join(',')+'/';
		} else {
			return '';
		}
		
	}
	
	doSearch() {
		console.log('test', this);
		let paramsBody = {
	      'from': (this.props.data.from)? parseInt(this.props.data.from, 10): 0,
	      'size': (this.props.data.size)? parseInt(this.props.data.size, 10): 4,
	      'query': {
	        "bool": {
	          "must": [
	            {
	              'query_string': {
	                'query': (this.state.query_string)? this.state.query_string: '*'
	              }
	            }
	          ]
	        }
	      }
	    };
	    let sortBy = {};
	    let sortByField = (this.props.data.sortField)? this.props.data.sortField: 'title';
	    sortBy[sortByField] = { 
	      'order': (this.props.data.sortOrder)? this.props.data.sortOrder: 'desc'
	    };
	    paramsBody.sort = [sortBy];
	    console.log('paramsBody', paramsBody);

	    axios({
		      method: 'POST',
		      url: '/search-api/'+this.getIndexesForSearch()+this.getTypesForSearch()+'_search',
		      headers: {
		        'Content-Type': 'application/json'
		      },
		      data: JSON.stringify(paramsBody)
		    }).then((response) => {
		      console.log('response.data', response.data);
		      this.setState({ data: response.data},() => {
		      });
		    })
		    .catch((error) => {
		      //console.log(error);
		    });
		    

	}

	/*componentDidMount() {
    let paramsBody = {
      'from': (this.props.data.from)? parseInt(this.props.data.from, 10): 0,
      'size': (this.props.data.size)? parseInt(this.props.data.size, 10): 4,
      'query': {
        "bool": {
          "must": [
            {
              'query_string': {
                'query': (this.props.data.query)? this.props.data.query: '*'
              }
            }
          ]
        }
      }
    };
    let sortBy = {};
    let sortByField = (this.props.data.sortField)? this.props.data.sortField: 'title';
    sortBy[sortByField] = { 
      'order': (this.props.data.sortOrder)? this.props.data.sortOrder: 'desc'
    };

    if(typeof this.props.data.audience !== 'undefined') {
      let audience = this.props.data.audience.split(',');
      audience.forEach(function(element) {
        paramsBody.query.bool.must.push( {term : {
          audience: jQuery.trim(element)
        }});
      });
      
    }

    paramsBody.sort = [sortBy];
    
    axios({
      method: 'POST',
      url: '/search-api/'+this.props.data.site+'/'+this.props.data.contentType+'/_search',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(paramsBody)
    }).then((response) => {
      console.log('response.data', response.data);
      this.setState({ data: response.data},() => {
        jQuery('.item-title').each(function() {
          jQuery(this).dotdotdot({});
        })

      })
    })
    .catch((error) => {
      //console.log(error);
    });
    
  }*/

	handleChange(e) {
	    var data = {};
	    data[e.target.name] = e.target.value;
	    this.setState(data);
	}

	handleSubmit(e) {
		//
		e.preventDefault();
		this.doSearch();
	}

	renderResults() {
		if(this.state.data.hits !== undefined) {
			if(this.state.data.hits.hits.length) {
				return (<div className="search-result">
		      		<ul>
				    	{this.state.data.hits.hits.map((d,i) =>
		                	<li key={d._id}>
						    	<pre><code>{JSON.stringify(d, null, 2) }</code></pre>
							</li>
		                )}

		      		</ul>
		      		
		      	</div>)
		    } else {
		    	return (<div className="search-result">
		      		<ul>
				    	<li>Your Search Produced 0 Results</li>
		      		</ul>
		      	</div>)
		    }
		} else {
			return null;
		}
	}
  	render() {
  		const { classes } = this.props;
	    return (
	      	<div className="search-component">
		      	<div className="search-form">
		      		<form onSubmit={ (e) => { this.handleSubmit(e);  } }> 
					  <div className="form-item">
					    <input 
					    	name="query_string" 
					    	onChange={ (e) => this.handleChange( e) } 
					    	value={this.state.query_string} 
					    	placeholder="Search NJIT" 
					    	className="search-field form-control form-text required" 
					    	type="text" 
					    	title="Search NJIT" 
					    	size="60" 
					    	maxLength="255"/>

					    <FormControl  className={classes.formControl}>
				          <InputLabel htmlFor="select-multiple-checkbox">Indexes</InputLabel>
				          <Select
				            multiple
				            name="select_indexes"
				            value={this.state.select_indexes}
				            onChange={this.handleChange}
				            input={<Input id="select-multiple-checkbox" />}
				            renderValue={selected => selected.join(', ')}
				            MenuProps={MenuProps}
				          >
				            {this.state.indexes.map( (item, i) => (
				              <MenuItem key={item.key} value={item.key}>
				                <Checkbox checked={this.state.select_indexes.indexOf(item.key) > -1} />
				                <ListItemText primary={item.key} />
				              </MenuItem>
				            ))}
				          </Select>
				        </FormControl>
					    
					    <FormControl  className={classes.formControl}>
				          <InputLabel htmlFor="select-multiple-checkbox">Content Types</InputLabel>
				          <Select
				            multiple
				            name="select_types"
				            value={this.state.select_types}
				            onChange={this.handleChange}
				            input={<Input id="select-multiple-checkbox" />}
				            renderValue={selected => selected.join(', ')}
				            MenuProps={MenuProps}
				          >
				            {this.state.types.map( (item, i) => (
				              <MenuItem key={item.key} value={item.key}>
				                <Checkbox checked={this.state.select_types.indexOf(item.key) > -1} />
				                <ListItemText primary={item.key} />
				              </MenuItem>
				            ))}
				          </Select>
				        </FormControl>
				        <div>
						    
						    <Button className={classes.button} onClick={this.clearResults} variant="contained" color="secondary">Clear Results</Button>
					  		<Button className={classes.button} type="submit" variant="contained" color="primary">Search</Button>
					  	</div>
					  </div>
					</form>
		      	</div>
		      	{this.renderResults()}
	      	</div>
	    );
  	}
}

NjitSearch.propTypes = {
  size: PropTypes.number,
  from: PropTypes.number,
  sortOrder: PropTypes.string,
  sortField: PropTypes.string,
  classes: PropTypes.object.isRequired,
//  query: PropTypes.string,
 
  // A value of any data type
 // site: PropTypes.string.isRequired,
 // contentType: PropTypes.string.isRequired,
 // keywords: PropTypes.array.isRequired,
};

export default withStyles(styles, { withTheme: true })(NjitSearch);








// WEBPACK FOOTER //
// ./src/Search/njitSearch.js